// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Buefy from 'buefy'
import router from './router'
import store from './store'
import './filters'
import mixin from './mixin'
import 'buefy/dist/buefy.css'
import VeeValidate, { Validator } from 'vee-validate'
import VCalendar from 'v-calendar'
import ja from 'vee-validate/dist/locale/ja'
import App from '@/components/mock/App'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import drag from "@branu-jp/v-drag";

Vue.use(Buefy, {
  defaultIconPack: 'mdi'
})

const config = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  dictionary: null,
  errorBagName: 'errors', // change if property conflicts
  events: 'blur',
  fieldsBagName: 'fields',
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: 'validations', // the nested key under which the validation messages will be located
  inject: true,
  locale: 'en',
  validity: false,
  useConstraintAttrs: true
};
Vue.use(VeeValidate, config)


Vue.use(VCalendar, {
  componentPrefix: 'vc'
})
Vue.use(drag)

Vue.mixin(mixin)

Validator.localize('ja', ja)
// カスタムバリデータ
Validator.extend('email2', {
  getMessage: field => `${field}の形式が正しくありません。`,
  validate: value => {
    // メールアドレスに「%」「*」が含まれている場合のみエラーにする
    if (value.indexOf("%") != -1 || value.indexOf("*") != -1) {
      return false
    }
    // var ret = /^([A-Za-z0-9]{1}[\+A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}.[A-Za-z0-9]{1,})$/.test(value)
    return true
  }
});
Validator.extend('zipCode', {
  getMessage: field => `${field}の形式が正しくありません。`,
  validate: value => {
    // 郵便番号
    // nnnm3-nnnn
    var ret = /^\d{3}-\d{4}$/.test(value)
    return ret
  }
});
Validator.extend('telephone', {
  getMessage: field => `${field}の形式が正しくありません。`,
  validate: value => {
    // 電話番号
    var ret = /^\d{2,4}-\d{2,4}-\d{4}$/.test(value)
    return ret
  }
});
Validator.extend('alpha_num_symbol', {
  getMessage: field => `${field}の形式が正しくありません。`,
  validate: value => {
    // 英数字、記号
    var ret = /^[!-~]+$/.test(value)
    return ret
  }
});
Validator.extend('alphaUpper_num', {
  getMessage: field => `${field}の形式が正しくありません。`,
  validate: value => {
    // 英大文字、数字
    var ret = /^[0-9A-Z]+$/.test(value)
    return ret
  }
});
Validator.extend('katakana', {
  getMessage: field => `${field}の形式が正しくありません。`,
  validate: value => {
    // 半カナ、全カナ、長音（-、ー)
    var ret = /^[ァ-ヴｦ-ﾟ\-\ー]+$/.test(value)
    return ret
  }
});
Validator.extend('password', {
  getMessage: field => `5文字以上の異なる文字を使用してください。`,
  validate: value => {
    var array1 = value.split('');
    var array2 = Array.from(new Set(array1));
    var ret = array2.length > 4
    return ret
  }
});
Validator.extend('selectRange', {
  getMessage: field => `${field}を選択してください。`,
  validate: (value, args) => {
    var arg = args.toString().split(':')
    var ret = (Number(value) >= Number(arg[0]) && value <= Number(arg[1]))
    return ret
  }
});
Validator.extend('selectBoolean', {
  getMessage: field => `${field}を選択してください。`,
  validate: (value) => {
    var valueLower = value.toString().toLowerCase()
    var ret = (valueLower === 'true' || valueLower === 'false')
    return ret
  }
});
Validator.extend('reportDest', {
  getMessage: field => `${field}を選択してください。`,
  validate(value) {
    var ret = (value === '患者' || value === '医療機関')
    return ret
  }
});
Validator.extend('gender', {
  getMessage: field => `${field}を選択してください。`,
  validate(value) {
    var ret = (value === '' || value === 'M' || value === 'F')
    return ret
  }
});
Validator.extend('anpyLevel', {
  getMessage: field => `${field}を選択してください。`,
  validate(value) {
    var ret = (value === '1' || value === '2' || value === '3')
    return ret
  }
});
Validator.extend('kanaCheck', {
  getMessage: field => `カタカナで入力してください。`,
  validate(value) {
    var kanaMap = {
      "ガ": "ｶﾞ", "ギ": "ｷﾞ", "グ": "ｸﾞ", "ゲ": "ｹﾞ", "ゴ": "ｺﾞ",
      "ザ": "ｻﾞ", "ジ": "ｼﾞ", "ズ": "ｽﾞ", "ゼ": "ｾﾞ", "ゾ": "ｿﾞ",
      "ダ": "ﾀﾞ", "ヂ": "ﾁﾞ", "ヅ": "ﾂﾞ", "デ": "ﾃﾞ", "ド": "ﾄﾞ",
      "バ": "ﾊﾞ", "ビ": "ﾋﾞ", "ブ": "ﾌﾞ", "ベ": "ﾍﾞ", "ボ": "ﾎﾞ",
      "パ": "ﾊﾟ", "ピ": "ﾋﾟ", "プ": "ﾌﾟ", "ペ": "ﾍﾟ", "ポ": "ﾎﾟ",
      "ヴ": "ｳﾞ", "ヷ": "ﾜﾞ", "ヺ": "ｦﾞ",
      "ア": "ｱ", "イ": "ｲ", "ウ": "ｳ", "エ": "ｴ", "オ": "ｵ",
      "カ": "ｶ", "キ": "ｷ", "ク": "ｸ", "ケ": "ｹ", "コ": "ｺ",
      "サ": "ｻ", "シ": "ｼ", "ス": "ｽ", "セ": "ｾ", "ソ": "ｿ",
      "タ": "ﾀ", "チ": "ﾁ", "ツ": "ﾂ", "テ": "ﾃ", "ト": "ﾄ",
      "ナ": "ﾅ", "ニ": "ﾆ", "ヌ": "ﾇ", "ネ": "ﾈ", "ノ": "ﾉ",
      "ハ": "ﾊ", "ヒ": "ﾋ", "フ": "ﾌ", "ヘ": "ﾍ", "ホ": "ﾎ",
      "マ": "ﾏ", "ミ": "ﾐ", "ム": "ﾑ", "メ": "ﾒ", "モ": "ﾓ",
      "ヤ": "ﾔ", "ユ": "ﾕ", "ヨ": "ﾖ",
      "ラ": "ﾗ", "リ": "ﾘ", "ル": "ﾙ", "レ": "ﾚ", "ロ": "ﾛ",
      "ワ": "ﾜ", "ヲ": "ｦ", "ン": "ﾝ",
      "ァ": "ｧ", "ィ": "ｨ", "ゥ": "ｩ", "ェ": "ｪ", "ォ": "ｫ",
      "ッ": "ｯ", "ャ": "ｬ", "ュ": "ｭ", "ョ": "ｮ",
      "。": "｡", "、": "､", "ー": "ｰ", "「": "｢", "」": "｣", "・": "･"
    };

    var kanaMap2 = {
      'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
      'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
      'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
      'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
      'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
      'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
      'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
      'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
      'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
      'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
      'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
      'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
      'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
      'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
      'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
      'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
      'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
      'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
      '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
    };

    var reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
    var reg2 = new RegExp('(' + Object.keys(kanaMap2).join('|') + ')', 'g');
    var hanKanaCnt = (value.match(reg) || []).length
    var zenKanaCnt = (value.match(reg2) || []).length
    var ret = false
    value = value.replace(/゛/g, '').replace(/゜/g, '').replace(/ﾞ/g, '').replace(/ﾟ/g, '').replace(/ /g, '').replace(/　/g, '')
    if (hanKanaCnt + zenKanaCnt
      == value.length) {
      ret = true
    }
    return ret
  }
});
Vue.config.productionTip = false

/* eslint-disable no-new */
var root = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

Vue.config.errorHandler = async (err, vm, info) => {
  try {
    await vm.sendError(err.stack, vm.$data)
  } catch (ex) {
    console.log(ex)
  }
};
window.addEventListener("error", async (event) => {
  try {
    await root.sendError(event.message + '\n' + event.error + '\n' + 'filename=' + event.filename + '\n'  + 'lineno=' + event.lineno + '\n'  + 'colno=' + event.colno)
  } catch (ex) {
    console.log(ex)
  }
});
window.addEventListener("unhandledrejection", async (event) => {
  try {
    await root.sendError('unhandledrejection: ' + event.reason)
  } catch (ex) {
    console.log(ex)
  }
});


// WEBPACK FOOTER //
// ./src/main.js